{
    "mainProgressBar": {
        "search": "Search",
        "deliveryOptions": "Delivery options",
        "recServices": "Recommended services",
        "booking": "Booking",
        "verification": "Verification"
    },
    "orderForm": {
        "title": "Ordering transport has never been so easy",
        "deliveryFrom": {
            "title": "Delivery from",
            "description": "Where do you ship?"
        },
        "deliveryTo": {
            "title": "Delivery to",
            "description": "Where do you ship to?"
        },
        "loadingItem": {
            "title": "Loading",
            "description": "What are you sending?"
        },
        "buttons": {
            "tariffSearch": "Tariff search"
        },
        "deliveryInput": {
            "countryFrom": "Country of departure",
            "countryTo": "Country of receipt",
            "zipFrom": "Departure postcode",
            "zipTo": "Receipt postcode",
            "cityFrom": "Departure city",
            "cityTo": "Receipt city",
            "zipCityFrom": "City/Departure postcode",
            "zipCityTo": "City/Receipt postcode",
            "countryPlaceholder": "Choose a country",
            "cityPlaceholder": "Enter the city",
            "zipCityPlaceholder": "Enter a city or zip code",
            "zipOrAddress": "Zip or address"
        },
        "loadingInput": {
            "tabTitles": {
                "partialLoading": "LTL Partial loading",
                "fullLoading": "FTL Full loading"
            },
            "buttons": {
                "addLoad": "Add load"
            },
            "partialLoading": {
                "cargoTypeTitle": "Cargo type",
                "cargoTypeValues": {
                    "cardboardBox": "Cardboard box",
                    "euroPallet": "European pallet (EUR 1.2x0.8)",
                    "palletFin": "Pallet (Fin 1.2x1.0)",
                    "palletInd": "Pallet (Ind 1.2x1.2)",
                    "other": "Other"
                },
                "loadingWithTailLift": "Loading with tail lift",
                "cargoDescription": {
                    "title": "Cargo description",
                    "placeholder": "Describe your product"
                },
                "submitSummaryInfo": "* - fields are mandatory"
            },
            "fullLoading": {
                "selectPresetTitle": "Select ready parameters:",
                "orSetManually": "or set them manually",
                "bodyType": {
                    "title": "Body type",
                    "placeholder": "Select body type",
                    "options": {
                        "bus": "Bus/Van",
                        "tent": "Tent",
                        "tentCurtain": "Curtainside",
                        "isotherm": "Isotherm",
                        "refrigerator": "Refrigerator",
                        "flatbed": "Flatbed",
                        "flatbedTent": "Flatbed tent",
                        "containerCarrier": "Container carrier",
                        "dumpTruck": "Dump truck",
                        "fullMetalVan": "Full metal van",
                        "mega": "Mega (extra volume)"
                    }
                },
                "carryingCapacity": {
                    "title": "Carrying capacity",
                    "placeholder": "1000 tons"
                },
                "loadingMetersLdm": {
                    "title": "Loading meters LDM",
                    "placeholder": "10 meters"
                },
                "loadingMethod": {
                    "title": "Loading method",
                    "placeholder": "Select loading method",
                    "options": {
                        "rear": "Rear",
                        "side": "Side",
                        "top": "Top"
                    }
                },
                "presets": {
                    "bus1100": {
                        "title": "Bus/Van up to 1100 kg",
                        "subtitle": "4-6 europallets"
                    },
                    "truck3500": {
                        "title": "Truck up to 3500 kg",
                        "subtitle": "14 europallets"
                    },
                    "truck5000": {
                        "title": "Truck up to 5000 kg",
                        "subtitle": "18-20 europallets"
                    },
                    "truck24000": {
                        "title": "Semi-trailer up to 24000 kg",
                        "subtitle": "33 europallets"
                    }
                },
                "loadingWithTailLift": "Loading with tail lift",
                "adrDangerousGoods": "Contains ADR dangerous goods",
                "cargoDescription": {
                    "title": "Cargo description",
                    "placeholder": "Describe your product"
                },
                "shippingDate": "Shipping date",
                "costOfCargo": "Cargo value",
                "submitSummaryInfo": "* - fields are mandatory"
            }
        }
    },
    "deliveryOptions": {
        "termDateLbl": "Term",
        "loadingDateLbl": "Loading",
        "deliveryDateLbl": "Delivery",
        "routeChangedWarning": "You changed the country or zip code. The selected tariff and additional services were reset, so you need to choose a delivery option again.",
        "termDataValue_one": "{{range}} day",
        "termDataValue_other": "{{range}} days",
        "standard": {
            "title": "Standard",
            "subtitle": "Reliable and cost-effective",
            "p1": "Optimal price for deliveries planned in advance",
            "p2": "Reliable transportation within standard transit times",
            "p3": "Support at every stage — by phone, chat and email",
            "p4": "Shipment tracking 24/7",
            "button": "Choose Standard"
        },
        "premium": {
            "title": "Premium",
            "subtitle": "Faster and prioritised",
            "badge": "Best choice",
            "p1": "Faster delivery with priority loading",
            "p2": "Select a fixed loading and/or delivery date",
            "p3": "Up to 3 days of storage — we will deliver on a day that suits you",
            "p4": "Support at every stage — by phone, chat and email",
            "p5": "Shipment tracking 24/7",
            "button": "Choose Premium"
        },
        "individual": {
            "title": "Direct",
            "subtitle": "Maximum speed on your schedule",
            "p1": "A dedicated vehicle exclusively for your shipment",
            "p2": "Direct delivery without consolidation with other cargo",
            "p3": "You choose the exact loading and delivery dates",
            "p4": "Maximum speed and control at every stage",
            "costValue": "Custom quote",
            "button": "Get a quote"
        }
    },
    "recommendedServices": {
        "title": "Personalize your transportation",
        "additionalServicesLbl": "Additional Services",
        "customsServicesLbl": "Customs services",
        "cargoServicesLbl": "Cargo services",
        "option": {
            "INS": {
                "title": "Cargo insurance",
                "tooltipTxt": "Cargo insurance. Lorem Ipsum is a placeholder text commonly used in the graphics, printing and publishing industries.",
                "content": "Lorem Ipsum is a placeholder text commonly used in the graphics, printing and publishing industries."
            },
            "ADR": {
                "title": "Carriage of dangerous goods (ADR)",
                "tooltipTxt": "ADR cargo handling includes the following classes: 3, 5.1, 5.2, 6.1, 8, 9. The offer does not apply to ADR classes 2.1, 2.2, 2.3, 4.1, 4.2, as well as high-risk cargo listed here. For individual offers on the above shipments, please contact your Vega representative.",
                "content": "Lorem Ipsum is a placeholder text commonly used in the graphics, printing and publishing industries."
            },
            "EX1": {
                "title": "Export registration",
                "tooltipTxt": "Export processing. Lorem Ipsum is a placeholder text commonly used in the graphics, printing and publishing industries.",
                "content": "Lorem Ipsum is a placeholder text commonly used in the graphics, printing and publishing industries."
            },
            "IM40": {
                "title": "Import registration",
                "tooltipTxt": "Import processing. Lorem Ipsum is a placeholder text commonly used in the graphics, printing and publishing industries.",
                "content": "Lorem Ipsum is a placeholder text commonly used in the graphics, printing and publishing industries."
            },
            "T1": {
                "title": "Certificate EUR1",
                "tooltipTxt": "Certificate EUR1. Lorem Ipsum is a placeholder text commonly used in the graphics, printing and publishing industries.",
                "content": "Lorem Ipsum is a placeholder text commonly used in the graphics, printing and publishing industries."
            },
            "LW": {
                "title": "Loading window",
                "tooltipTxt": "Loading is carried out within 2 days from the date specified in the selected tariff. Loading on the exact date is possible only in the 'Individual' tariff. You can also choose the additional service 'Loading Window' if you need your cargo to be picked up before lunch (9:00-13:00) or after lunch (13:00-17:00).",
                "datePickerName": "Upload date",
                "cargoTimeName": "Shipping time",
                "switchName": "Choose shipping times"
            },
            "DW": {
                "title": "Delivery window",
                "tooltipTxt": "In this delivery option, the delivery date is determined by the date of cargo pick-up. We will deliver your cargo as quickly as possible, adhering to the standard transit time after pick-up. For groupage cargo, you can also book a specific date and time for delivery using the 'Delivery Window' service, which is available for any tariff. In this case, your cargo will be temporarily stored in our warehouse until the agreed delivery date.",
                "datePickerName": "Delivery date",
                "cargoTimeName": "Delivery time",
                "switchName": "Choose delivery times"
            }
        },
        "card": {
            "internationalDeliveryLbl": "International delivery"
        }
    },
    "verification": {
        "cargoDataCard": {
            "title": "Cargo data (LTL)"
        }
    },
    "booking": {
        "loadingAddressCard": {
            "title": "Loading address"
        },
        "receivingAddress": {
            "title": "Receiving address"
        },
        "addToAddressBookLbl": "Add to address book",
        "addressChangedWarning": "If you change your address, the shipping cost may change"
    },
    "orderConfirmation": {
        "title": {
            "p1": "Your application has been successfully submitted",
            "p2": "After checking our specialists, you will receive a confirmation on your email"
        },
        "body": {
            "title": "What's next?",
            "info": [
                {
                    "title": "Order Verification and Confirmation",
                    "p": "After that, you will receive a confirmation letter to your email."
                },
                {
                    "title": "Order Payment",
                    "p": "Next, we will issue you an invoice. After payment, your order will be confirmed and processed."
                },
                {
                    "title": "Clarification of Details ",
                    "p": "Our specialists will contact your sender and agree on the shipment details."
                },
                {
                    "title": "Document Verification",
                    "p": "To ensure that there are no delays in the delivery process, and if necessary, we will notify you of the necessary corrections."
                },
                {
                    "title": "Order Fulfillment Process",
                    "p": "You will be able to track the status of your order by track number 24/7."
                },
                {
                    "title": "Document Verification",
                    "p": "To ensure that there are no delays in the delivery process, and if necessary, we will notify you of the necessary corrections."
                },
                {
                    "title": "Order fulfillment process",
                    "p": "You will be able to track the status of your order by track number 24/7."
                }
            ]
        },
        "contacts": {
            "p1": "Do you have any questions?",
            "p2": "Contact us in a way convenient for you"
        },
        "finalConfirmation": {
            "title": "Tell us about your experience",
            "rateExperienceTitle": "Rate your latest experience",
            "yourExperienceTitle": "Your feedback:",
            "notePlaceholder": "This is where you write your feedback. Explain what happened and avoid using offensive language. Keep your feedback honest, helpful, and constructive."
        }
    }
}